<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)
const props = defineProps({
  imgList: {
    type: Array,
    required: true
  },
  basetime: {
    type: Number,
    required: true
  }
})
const sliderValue = useState('sliderValue', () => {
  const index = props.imgList.findIndex((item) => item.tm === props.basetime)
  return index === -1 ? 0 : index
})
const imageStatusMap = ref({})
props.imgList.forEach((_, idx) => {
  if (!(idx in imageStatusMap.value)) {
    imageStatusMap.value[idx] = 'pending'
  }
})

const handleImgLoad = (key) => {
  imageStatusMap.value[key] = 'loaded'
}
const handleImgError = (key) => {
  imageStatusMap.value[key] = 'error'
}
</script>

<template>
  <section class="content">
    <SectionTitle
      title="過去の天気図"
      :date="`${dayjs.unix(props.basetime).tz('Asia/Tokyo').format('YYYY年M月D日')}`"
    />
    <div>
      <figure>
        <ClientOnly>
          <template v-if="props.imgList[sliderValue].pc && props.imgList[sliderValue].sp">
            <picture v-if="imageStatusMap[sliderValue] !== 'error'">
              <source
                :srcset="`https://gvs.weathernews.jp/${props.imgList[sliderValue].pc}`"
                media="(min-width: 830px)"
              >
              <img
                :src="`https://gvs.weathernews.jp/${props.imgList[sliderValue].sp}`"
                alt=""
                @load="handleImgLoad(sliderValue)"
                @error="handleImgError(sliderValue)"
              >
            </picture>
            <div
              v-else
              class="text-area"
            >
              <p>no data</p>
            </div>
          </template>
        </ClientOnly>
      </figure>
      <PastChartTimeZagSlider
        v-model:slider-value="sliderValue"
        :label-list="props.imgList.map((item) => item.tm)"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  figure {
    width: 100%;
    aspect-ratio: 75 / 68;
    img {
      width: 100%;
      height: auto;
    }
    .text-area {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background-color: #F9F9F9;
      p {
        color: #808080;
        font-size: 24px;
        font-weight: 600;
        line-height: 1em;
      }
    }
  }
}
@media screen and (min-width: 830px) {
  .content {
    figure {
      aspect-ratio: 151 / 100;
    }
  }
}
</style>
